import useSuspensionBanners from '../hooks/useSuspensionBanners';
import { jsx as _jsx } from "react/jsx-runtime";
function withSuspensionBanners(scope) {
  return function (Component) {
    return function (props) {
      const {
        bannerVisible,
        scopeDisabled
      } = useSuspensionBanners(scope);
      return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
        bannerVisible: bannerVisible,
        scopeDisabled: scopeDisabled
      }));
    };
  };
}
export default withSuspensionBanners;